var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViews(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1930",
    "data-name": "Group 1930",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.284,
    height: 17.436,
    viewBox: "0 0 29.284 17.436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4995",
    "data-name": "Path 4995",
    d: "M1481.6,166.053a20.99,20.99,0,0,1,3.176-3.606,17.47,17.47,0,0,1,8.494-4.477,15.32,15.32,0,0,1,10.189,1.493,21.2,21.2,0,0,1,7.166,6.215,1.135,1.135,0,0,1-.006,1.451,21.212,21.212,0,0,1-7.276,6.26,15.572,15.572,0,0,1-5.6,1.646,16.024,16.024,0,0,1-11.353-3.356,22.578,22.578,0,0,1-4.5-4.522,5.14,5.14,0,0,1-.29-.477Zm14.713,6.492a6.149,6.149,0,1,0-6.227-5.967A6.139,6.139,0,0,0,1496.313,172.545Z",
    transform: "translate(-1481.6 -157.671)",
    fill: "#777e90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4997",
    "data-name": "Path 4997",
    d: "M1563.707,197.045a3.314,3.314,0,1,1-3.251-3.326A3.307,3.307,0,0,1,1563.707,197.045Z",
    transform: "translate(-1545.752 -188.31)",
    fill: "#777e90"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViews);
export default __webpack_public_path__ + "static/media/views.dc08096f26bc211fd84b920b38586e4b.svg";
export { ForwardRef as ReactComponent };